import api from "./api";
import moment from "moment";

const today = () => moment().format("YYYY-MM-DD");

const dateRange = (debut, fin) => ({
  date_debut: debut ?? today(),
  date_fin: fin ?? today(),
});

export const getMomoStats = (debut, fin) =>
  api.post("/dashboard-momo-stats", dateRange(debut, fin));

export const getVenteMomoByYear = () =>
  api.get("/stat_vente_momo_by_year");

export const importMomoFile = (formData) =>
  api.post("/import-momo-file", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const importMomoDeleteFile = (formData) =>
  api.post("/import-momo-delete-file", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
